export default __webpack_public_path__ + "static/media/mapa.4276c6b6.svg";